import * as InternalTypes from '../common/InternalTypes';
import { LoggerTexts } from '../common/LoggerTexts';
import { Util } from '../common/Util';
import { InstantPushConfig } from '../config/push/InstantPushConfig';

export class InstantPushConfigState {
	private _areaId: string;
	private _triggerName: string;
	private _triggeredCount = 0;
	private _executedCount = 0;
	private _nextPushDateTime: number;

	init(areaId: string, triggerName: string, _nextPushDateTime: number, triggeredCount?: number, executedCount?: number) {
		if (!areaId || Util.stringIsEmpty(areaId)) {
			throw Error(LoggerTexts.INSTANT_PUSH_CFG.AREAID_CANNOT_BE_EMTPY);
		}
		if (!triggerName || Util.stringIsEmpty(triggerName)) {
			throw Error(LoggerTexts.INSTANT_PUSH_CFG.TRIGGERNAME_CANNOT_BE_EMTPY);
		}
		this._areaId = areaId;
		this._triggerName = triggerName;
		this._nextPushDateTime = _nextPushDateTime;
		this._triggeredCount = triggeredCount ?? 0;
		this._executedCount = executedCount ?? 0;
	}

	initFromJsonObject(instantPushState: InternalTypes.InstantPushConfigState) {
		const { areaId, triggerName, nextPushDateTime, triggeredCount, executedCount } = instantPushState;
		this.init(areaId, triggerName, nextPushDateTime, triggeredCount, executedCount);
	}

	get combinedKey(): string {
		return Util.getCombinedKey(this._areaId, this._triggerName);
	}

	get areaId() {
		return this._areaId;
	}

	get triggerName() {
		return this._triggerName;
	}

	get triggeredCount(): number {
		return this._triggeredCount;
	}

	get executedCount(): number {
		return this._executedCount;
	}

	get nextPushDateTime(): number {
		return this._nextPushDateTime;
	}

	increaseTriggeredCount() {
		this._triggeredCount++;
	}

	increaseExecutedCount() {
		this._executedCount++;
	}

	updateNextPushDateTime(nextPushDateTime: number) {
		this._nextPushDateTime = nextPushDateTime;
	}

	isQualifiedForPush(instantPushConfig: InstantPushConfig): boolean {
		if (this._hasNotReachedMaxLimit(instantPushConfig)) {
			return true;
		}
		return false;
	}

	private _hasNotReachedMaxLimit(instantPushConfig: InstantPushConfig) {
		return this.executedCount < instantPushConfig.maxLimit;
	}

	get instantPushConfigObject(): InternalTypes.InstantPushConfigState {
		const instantPushConfigJsonObject: InternalTypes.InstantPushConfigState = {
			areaId: this.areaId,
			triggerName: this.triggerName,
			nextPushDateTime: this.nextPushDateTime
		};
		if (this.triggeredCount >= 0) {
			instantPushConfigJsonObject.triggeredCount = this.triggeredCount;
		}
		if (this.executedCount >= 0) {
			instantPushConfigJsonObject.executedCount = this.executedCount;
		}
		return instantPushConfigJsonObject;
	}
}
